import { c as _c } from "react/compiler-runtime";
export interface MenuSectionProps {
  title: string;
  children: React.ReactNode;
}
export const MenuSection = t0 => {
  const $ = _c(5);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="px-2 py-1 text-xs font-medium text-muted-foreground/70">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className="space-y-0.5">{t1}{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};